export default '/build/bce5dbb6.svg'